export default "__VITE_ASSET__DTyifsLl__"